export default "__VITE_ASSET__9939c562__"